import React from 'react';
import { useApiError } from '../../../hooks/useApiError';
import ApiErrorPage from '../ApiErrorPage';

const GlobalApiError = () => {
  const { error, isVisible, level, handleRetry, handleGoHome } = useApiError();

  if (!isVisible || !error) {
    return null;
  }

  if (level === 'page') {
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999,
        backgroundColor: 'var(--color-background, #ffffff)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <ApiErrorPage
          error={error}
          onRetry={handleRetry}
          onGoHome={handleGoHome}
          level="page"
        />
      </div>
    );
  }

  return (
    <ApiErrorPage
      error={error}
      onRetry={handleRetry}
      onGoHome={handleGoHome}
      level="component"
    />
  );
};

export default GlobalApiError;